var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', {
    staticClass: "mb-2"
  }, [_vm._v(_vm._s(_vm.id ? 'Editar' : 'Cadastrar') + " Pesquisador")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome Completo",
      "label-for": "fullName"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "fullName",
      "placeholder": "Nome Completo"
    },
    model: {
      value: _vm.form.fullName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fullName", $$v);
      },
      expression: "form.fullName"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Email",
      "label-for": "email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "email@exemplo.com"
    },
    model: {
      value: _vm.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Área do Pesquisador"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.areaOptions,
      "reduce": function reduce(val) {
        return val.value;
      },
      "label": "text",
      "placeholder": "Selecione uma área"
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function fn() {
        return [_vm._v(" Nenhum resultado encontrado ")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selectedArea,
      callback: function callback($$v) {
        _vm.selectedArea = $$v;
      },
      expression: "selectedArea"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Senha",
      "label-for": "password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "Senha"
    },
    model: {
      value: _vm.form.password,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Confirmar Senha",
      "label-for": "confirmPassword"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "confirmPassword",
      "type": "password",
      "placeholder": "Confirmar Senha"
    },
    model: {
      value: _vm.form.confirmPassword,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "confirmPassword", $$v);
      },
      expression: "form.confirmPassword"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Ativo"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.active,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "active", $$v);
      },
      expression: "form.active"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.active ? 'Sim' : 'Não') + " ")])], 1)], 1), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(" Salvar ")]), _c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "to": {
        name: 'PesquisadorLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }